
import axios from 'axios';
import { config } from './config';
import { msalInstance } from './authConfig';
import { getAccessToken } from './services/authService';
//
// Create axios instance with base configuration
const api = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include x-functions-key and x-admin-email
api.interceptors.request.use(
  async (config) => {
    // Add Azure Functions host key from environment variable
    const functionKey = import.meta.env.VITE_FUNCTION_KEY;
    if (functionKey) {
      config.headers['x-functions-key'] = functionKey;
    } else {
      console.warn(`[API Interceptor] No function key available for ${config.url}`);
    }

    // Add x-admin-email header for authenticated admin users
    if (msalInstance) {
      const accounts = msalInstance.getAllAccounts();
      if (accounts && accounts.length > 0) {
        const email = accounts[0].username;
        if (email) {
          config.headers['x-admin-email'] = email;
        }
        // Attach access token for API requests
        const token = await getAccessToken();
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API Interceptor] Response error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      data: error.response?.data
    });
    
    if (error.response?.status === 401) {
      // Token expired or invalid
      console.warn('[API Interceptor] 401 Unauthorized - token invalid or expired');
      // Don't auto-redirect here - let components handle 401 errors
      // Components should check for 401 and handle appropriately
    }
    
    return Promise.reject(error);
  }
);

export default api;

// Helper function for API calls that return data
export const apiCall = async (url: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET', data?: any) => {
  const response = await api.request({
    url,
    method,
    data
  });
  return response.data;
};
